// extracted by mini-css-extract-plugin
export default {"card-image":"lilFd","image-wrapper":"lONHf","card-text":"dKF_X","card":"u3oxC","text-icon":"p3lj3","icon-settings":"QgLha","icon-student":"hHP_s"};